<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-row class="pa-2">
          <v-col cols="6">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
               <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                filled
                @change="getDataBranch(Company)"
                hide-details
                label="บริษัท"
                prepend-inner-icon="mdi-map-marker-radius"
                class="ma-2"
            ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                filled
                hide-details
                prepend-inner-icon="mdi-map-marker"
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                filled
                hide-details
                prepend-inner-icon="mdi-briefcase"
                label="แผนก"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>

          <v-col cols="6">
            <v-sheet tile height="54" class="d-flex">
              <!-- วัน -->
              <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                label="วัน"
                class="ma-2"
              ></v-select>
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <v-btn
                class="ml-5 mt-2"
                color="#173053"
                dark
                @click="getData()"
              >
                <v-icon left size="20"
                  >mdi-calendar-search</v-icon
                >
                ค้นหา
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row class="pa-5" >
          <v-col
            elevation="10"
            cols="4"
          >
            <v-card
              rounded="xl"
              class="text-white"
              color="#130A29"
              elevation="5"
            >
              <v-row class="pb-2 pt-3 pl-5 ">
                <v-col cols="2" style="padding: 0px 15px 0px;">
                  <v-icon color="white" class="mdi-36px"
                    >mdi-chart-box</v-icon
                  >
                </v-col>
                <v-col>
                  <p class="font-weight-black">พนักงานทั้งหมด</p>
                </v-col>
              </v-row>

              <v-card-text>
                <v-row class="pl-6 ">
                  <v-col class="text-h3 text-white text-center" cols="8">{{ empCountAll }}</v-col>
                  <h4 class="pt-8 pr-2 text-white">คน</h4>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            elevation="10"
            cols="2"
          >
            <v-card
              rounded="xl"
              class="text-white"
              color="#4BAC56"
              elevation="5"
            >
              <v-row class="pb-2 pt-3 pl-5 ">
                <v-col cols="2" style="padding: 0px 15px 0px;">
                  <v-icon color="white" class="mdi-36px"
                    >mdi-chart-box</v-icon
                  >
                </v-col>
                <v-col>
                  <p class="font-weight-black">สีเขียว</p>
                </v-col>
              </v-row>

              <v-card-text>
                <v-row class="pl-6 ">
                  <v-col class="text-h3 text-white" cols="8">{{ coutGreen }}</v-col>
                  <h4 class="pt-8 pr-2 text-white">คน</h4>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            elevation="10"
            cols="2"
          >
            <v-card
              rounded="xl"
              class="text-white"
              color="#FFC727"
              elevation="5"
            >
              <v-row class="pb-2 pt-3 pl-5 ">
                <v-col cols="2" style="padding: 0px 15px 0px;">
                  <v-icon color="white" class="mdi-36px"
                    >mdi-chart-box</v-icon
                  >
                </v-col>
                <v-col>
                  <p class="font-weight-black">สีเหลือง</p>
                </v-col>
              </v-row>

              <v-card-text>
                <v-row class="pl-6 ">
                  <v-col class="text-h3 text-white" cols="8">{{ coutYellow }}</v-col>
                  <h4 class="pt-8 pr-2 text-white">คน</h4>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            elevation="10"
            cols="2"
          >
            <v-card
              rounded="xl"
              class="text-white"
              color="#EA7623"
              elevation="5"
            >
              <v-row class="pb-2 pt-3 pl-5 ">
                <v-col cols="2" style="padding: 0px 15px 0px;">
                  <v-icon color="white" class="mdi-36px"
                    >mdi-chart-box</v-icon
                  >
                </v-col>
                <v-col>
                  <p class="font-weight-black">สีส้ม</p>
                </v-col>
              </v-row>

              <v-card-text>
                <v-row class="pl-6 ">
                  <v-col class="text-h3 text-white" cols="8">{{ coutOrange }}</v-col>
                  <h4 class="pt-8 pr-2 text-white">คน</h4>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            elevation="10"
            cols="2"
          >
            <v-card
              rounded="xl"
              class="text-white"
              color="#EA272E"
              elevation="5"
            >
              <v-row class="pb-2 pt-3 pl-5 ">
                <v-col cols="2" style="padding: 0px 15px 0px;">
                  <v-icon color="white" class="mdi-36px"
                    >mdi-chart-box</v-icon
                  >
                </v-col>
                <v-col>
                  <p class="font-weight-black">สีแดง</p>
                </v-col>
              </v-row>

              <v-card-text>
                <v-row class="pl-6 ">
                  <v-col class="text-h3 text-white" cols="8">{{ coutRed }}</v-col>
                  <h4 class="pt-8 pr-2 text-white">คน</h4>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="pa-5">
          <v-col cols="6">
            <v-card rounded="xl">
              <v-card-title class="text-h6">
                <v-icon left> mdi-chart-pie </v-icon>
                จำนวนทั้งหมด
              </v-card-title>
              <canvas class="pa-5" id="myChartTotalRisk"></canvas>
            </v-card>
          </v-col>
            <v-col cols="6">
            <v-card rounded="xl">
              <v-card-title class="text-h6">
                <v-icon left>  mdi-chart-bar </v-icon>
                จำนวนที่ทำแบบประเมินความเสี่ยง
              </v-card-title>
              <canvas class="pa-5" id="myChartTypeRisk"></canvas>
            </v-card>
          </v-col>
            </v-row>

        <v-row v-if="disableExport">
          <!-- data table -->
          <v-col cols="12">
            <v-row cols="12">
              <v-col cols="6">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title> รายชื่อพนักงานทำแบบประเมินแล้ว </v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-blue"
                      :headers="columns"
                      :items="dataItemComplate"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title>
                    รายชื่อพนักงานที่ยังไม่ทำแบบประเมิน
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-purple"
                      :headers="columnsUnRisk"
                      :items="dataItemCantRisk"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row cols="12">
              <template>
                <v-toolbar
                  class="mb-2"
                  color="grey lighten-2"
                  flat
                >
                <v-col class="text-center">
                  <v-toolbar-title>รายชื่อพนักงานที่ทำแบบประเมินแล้ว รายละเอียด อาการ แบ่งตามสีความเสี่ยง</v-toolbar-title>
                </v-col>
                </v-toolbar>
              </template>
              <v-col cols="12">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title> สีแดง {{coutRed}}</v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-red"
                      :headers="columnsRisk"
                      :items="dataItemRed"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.formSaveRisk21`]="{ item }">
                        {{ item.formSaveRisk21 }}
                        <v-chip class="ma-2" label v-if="!item.formSaveRisk21">
                          ไม่แสดงอาการ
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title> สีส้ม {{coutOrange}}</v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-orange"
                      :headers="columnsRisk"
                      :items="dataItemOrange"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.formSaveRisk21`]="{ item }">
                        {{ item.formSaveRisk21 }}
                        <v-chip class="ma-2" label v-if="!item.formSaveRisk21">
                          ไม่แสดงอาการ
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row cols="12">
              <v-col cols="12">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title> สีเหลือง {{coutYellow}}</v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-yellow"
                      :headers="columnsRisk"
                      :items="dataItemYellow"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.formSaveRisk21`]="{ item }">
                        {{ item.formSaveRisk21 }}
                        <v-chip class="ma-2" label v-if="!item.formSaveRisk21">
                          ไม่แสดงอาการ
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card elevation="7" v-if="dataReady">
                  <v-card-title> สีเขียว {{coutGreen}}</v-card-title>
                  <v-card-text>
                    <v-data-table
                      id="header-green"
                      :headers="columns"
                      :items="dataItemGreen"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <template>
                <v-toolbar
                  class="mb-2"
                  color="grey lighten-2"
                  flat
                >
                <v-col class="text-center">
                  <v-toolbar-title>แผนภูมิ 14 วันล่าสุดตามสีความเสี่ยง</v-toolbar-title>
                </v-col>
                </v-toolbar>
              </template>

              <v-row class="pa-5">
          <v-col cols="12">
            <v-card rounded="xl">
              <!-- <v-card-title class="text-h6">
                <v-icon left> mdi-chart-pie </v-icon>
                จำนวนทั้งหมด
              </v-card-title> -->
              <canvas class="pa-5" id="myChartRiskretRoact"></canvas>
            </v-card>
          </v-col>
            </v-row>

            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import XLSX from 'xlsx' // import xlsx
import moment from 'moment' // แปลง date
import dayName from '../../assets/master/Date/day.json'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
import { gmapApi } from 'vue2-google-maps'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    XLSX,
    moment,
    gmapApi
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    }
  },
  data () {
    return {
      PK: '',
      center: {},
      session: this.$session.getAll(),
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายงาน Covid-19',
          disabled: false,
          href: '/CheckINOUT/ReportCovidHelp'
        }
      ],
      dialog: false,
      dataReady: true,
      dateTime: '', // Generate DateTime
      searchAll2: '',
      loader: null,
      loading3: false,
      date: new Date().toISOString().substr(0, 10),
      // Data Table Config
      columns: [
        { text: 'ชื่อ - นามสกุล', value: 'empFull_NameTH', align: 'center' },
        { text: 'แผนก', value: 'masDepartmentName', align: 'center' },
        { text: 'สาขา', value: 'masBranchName', align: 'center' },
        { text: 'บริษัท', value: 'masCompanyName', align: 'center' }
      ],
      columnsUnRisk: [
        { text: 'ชื่อ - นามสกุล', value: 'empFull_NameTH', align: 'center' },
        { text: 'แผนก', value: 'masDepartmentName', align: 'center' },
        { text: 'สาขา', value: 'masBranchName', align: 'center' },
        { text: 'บริษัท', value: 'masCompanyName', align: 'center' }
      ],
      columnsRisk: [
        { text: 'ชื่อ - นามสกุล', value: 'empFull_NameTH', align: 'center' },
        { text: 'แผนก', value: 'masDepartmentName', align: 'center' },
        { text: 'สาขา', value: 'masBranchName', align: 'center' },
        { text: 'บริษัท', value: 'masCompanyName', align: 'center' },
        { text: 'อาการ', value: 'formSaveRisk21', align: 'center' }
      ],
      colorItemlist: ['สีเขียว', 'สีเหลือง', 'สีส้ม', 'สีแดง'],
      dataItem: [],
      dataExportItem: [],
      dataByEmp: [],
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      disableBranch: true,
      disableDeparment: true,
      disableSearch: false,
      disableExport: false,
      year: '',
      month: '',
      day: '',
      disableYear: true,
      disableMonth: true,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      empCountAll: 0,
      coutRiskDone: 0,
      coutRiskEmpty: 0,
      coutGreen: 0,
      coutYellow: 0,
      coutOrange: 0,
      coutRed: 0,
      dataItemGreen: [],
      dataItemOrange: [],
      dataItemYellow: [],
      dataItemRed: [],
      dataItemComplate: [],
      dataItemCantRisk: []
    }
  },
  async mounted () {
    this.dataReady = false

    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()

    await this.getGetToken()

    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
    // await this.getDataItemRoact()
    await this.getData()
  },
  methods: {
    async getData () {
      await this.getDataToday()
      await this.getDataTodayChartData()
    },
    async getDataToday () {
      this.dataReady = false

      this.coutGreen = 0
      this.coutYellow = 0
      this.coutOrange = 0
      this.coutRed = 0

      var Company = (this.Company === '' ? '' : '&masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)

      this.colorItemlist.forEach(async (element) => {
        //  console.log(element)
        if (element) {
          await axios
            .get(
              // eslint-disable-next-line quotes
              this.DNS_IP +
                '/shift_import/get?shiftDay=' +
                this.day +
                '&shiftMonth=' +
                this.getMonthThToINT(this.month) +
                '&shiftYear=' +
                this.year +
                '&color=' +
                element +
                Company +
                Branch +
                Department,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.dataReady = true
              this.disableExport = true // Show Export
              // 'สีเขียว', 'สีเหลือง', 'สีส้ม', 'สีแดง'
              this.dataExportItem = response.data

              if (element === 'สีเขียว') {
                this.dataItemGreen = response.data
              }
              if (element === 'สีเหลือง') {
                this.dataItemYellow = response.data
              }
              if (element === 'สีส้ม') {
                this.dataItemOrange = response.data
              }
              if (element === 'สีแดง') {
                this.dataItemRed = response.data
              }
              await this.getDataCountEmployee()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              //  console.log(error)
              this.dataReady = true
            })
        }
      })
    },
    async getDataTodayComplete () {
      this.dataReady = false
      this.dataItemComplate = []
      var Company = (this.Company === '' ? '' : '&masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getIsNotNullRisk?shiftDay=' +
            this.day +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&isnull=true&shiftYear=' +
            this.year +
                Company +
                Branch +
                Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.disableExport = true // Show Export
          this.dataItemComplate = response.data
          // this.getData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
          this.dataReady = true
        })
    },
    async getDataTodayCant () {
      this.dataReady = false
      this.dataItemCantRisk = []
      var Company = (this.Company === '' ? '' : '&masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getIsNullRisk?shiftDay=' +
            this.day +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year + '&isnull=true' +
                Company +
                Branch +
                Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          // this.disableExport = true // Show Export
          this.dataItemCantRisk = response.data
          console.log('dataItemCantRisk', this.dataItemCantRisk)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
          this.dataReady = true
        })
    },
    async getDataItemRoact () {
      this.dataReady = false
      this.dataItemRoact = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getLastDayRisk?shiftDay=' +
            this.day +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year + '&isnull=true',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItemRoact = response.data
          console.log('dataTest', this.dataItemRoact)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataTodayChartData () {
      this.dataReady = false
      this.dataItem = []
      this.coutRiskDone = 0
      this.coutRiskEmpty = 0
      this.coutGreen = 0
      this.coutYellow = 0
      this.coutOrange = 0
      this.coutRed = 0

      var Company = this.Company === '' ? '' : '&masCompanyName=' + this.Company
      var Branch = this.Branch === '' ? '' : '&masBranchName=' + this.Branch
      var Department =
        this.Department === '' ? '' : '&masDepartmentName=' + this.Department

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?shiftDay=' +
            this.day +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year +
            Company +
            Branch +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItem = response.data
          this.dataItem.forEach(shifttem => {
            if (shifttem.color) {
              this.coutRiskDone += 1
            } else {
              this.coutRiskEmpty += 1
            }

            if (shifttem.color === 'สีเขียว') {
              this.coutGreen += 1
            }
            if (shifttem.color === 'สีเหลือง') {
              this.coutYellow += 1
            }
            if (shifttem.color === 'สีส้ม') {
              this.coutOrange += 1
            }
            if (shifttem.color === 'สีแดง') {
              this.coutRed += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
        })
      console.log('ประเมินแล้ว', this.coutRiskDone)
      console.log('ยังไม่ประเมิน', this.coutRiskEmpty)
      this.coutRiskDone = this.coutRiskDone < 0 ? 0 : this.coutRiskDone
      this.coutRiskEmpty = this.coutRiskEmpty < 0 ? 0 : this.coutRiskEmpty
      console.log('สีเขียว', this.coutGreen)
      console.log('สีเหลือง', this.coutYellow)
      console.log('สีส้ม', this.coutOrange)
      console.log('สีแดง', this.coutRed)
      this.coutGreen = this.coutGreen < 0 ? 0 : this.coutGreen
      this.coutYellow = this.coutYellow < 0 ? 0 : this.coutYellow
      this.coutOrange = this.coutOrange < 0 ? 0 : this.coutOrange
      this.coutRed = this.coutRed < 0 ? 0 : this.coutRed

      await this.searchCharJSTotalRisk()
      await this.searchCharJSTypeRisk()
      await this.getDataTodayComplete()
      await this.getDataTodayCant()
      await this.searchCharJSRiskretRoact()
    },
    async searchCharJSTotalRisk () {
      var ctx = document.getElementById('myChartTotalRisk')
      var myChartTotalRisk = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'pie',
        data: {
          labels: ['ทำแบบประเมินแล้ว', 'ไม่ได้ทำแบบประเมิน'],
          datasets: [
            {
              backgroundColor: ['#219EBC', '#023047'],
              data: [this.coutRiskDone, this.coutRiskEmpty]
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            datalabels: {
              color: 'white',
              textAlign: 'center',
              font: {
                weight: 'bold',
                size: 18
              }
            }
          }
        }
      })
      console.log(myChartTotalRisk)
    },
    async searchCharJSTypeRisk () {
      console.log('สีเขียว', this.coutGreen)
      console.log('สีเหลือง', this.coutYellow)
      console.log('สีส้ม', this.coutOrange)
      console.log('สีแดง', this.coutRed)
      var ctx = document.getElementById('myChartTypeRisk')
      var myChartTypeRisk = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {datasets: [
          {
            label: 'สีเขียว',
            data: [this.coutGreen],
            borderWidth: 1,
            backgroundColor: 'green'
          },
          {
            label: 'สีเหลือง',
            data: [this.coutYellow],
            borderWidth: 1,
            backgroundColor: 'yellow'
          },
          {
            label: 'สีส้ม',
            data: [this.coutOrange],
            borderWidth: 1,
            backgroundColor: 'orange'
          },
          {
            label: 'สีแดง',
            data: [this.coutRed],
            borderWidth: 1,
            backgroundColor: 'red'
          }],
        onclick: function (d, i) { console.log('onclick', d, i) }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartTypeRisk)
    },
    async searchCharJSRiskretRoact () {
      var ctx = document.getElementById('myChartRiskretRoact')
      var myChartRiskretRoact = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'horizontalBar',
        data: {
          datasets: [
            {
              label: 'สีเขียว',
              data: [this.coutGreen],
              borderWidth: 1,
              backgroundColor: 'green'
            },
            {
              label: 'สีเหลือง',
              data: [this.coutYellow],
              borderWidth: 1,
              backgroundColor: 'yellow'
            },
            {
              label: 'สีส้ม',
              data: [this.coutOrange],
              borderWidth: 1,
              backgroundColor: 'orange'
            },
            {
              label: 'สีแดง',
              data: [this.coutRed],
              borderWidth: 1,
              backgroundColor: 'red'
            }]
        },
        options: {
          scales: {
            yAxes: [{
              stacked: true
            }],
            xAxes: [{
              stacked: true
            }]
          }
        }
      })
      console.log(myChartRiskretRoact)
    },
    async getDataCountEmployee () {
      this.empCountAll = 0

      var Company = this.Company === '' ? '' : '&masCompanyName=' + this.Company
      var Branch = this.Branch === '' ? '' : '&masBranchName=' + this.Branch
      var Department =
        this.Department === '' ? '' : '&masDepartmentName=' + this.Department
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/employee/get?RECORD_STATUS=N' +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.empCountAll = response.data.length
          console.log('empCountAll', this.empCountAll)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    async getByEmp (dt) {
      dt.empImageUrl = this.DNS_IP + '/' + dt.empImageUrl
      this.dataReady = false
      this.dataByEmp = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?empCode=' +
            dt.empCode +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year
        )
        .then(async (response) => {
          this.dataReady = true
          dt.shifttem = response.data
          dt.shifttemMapCheckIn = response.data
          this.mapGetDataCheckRisk(dt.shifttemMapCheckIn)
          dt.shifttem.forEach((shifttem) => {
            if (shifttem.checkInStartStamp) {
              var date =
                shifttem.checkInYear +
                '-' +
                shifttem.checkInMonth +
                '-' +
                shifttem.checkInDay
              var startStamp = new Date(
                date + ' ' + shifttem.checkInStartStamp
              )
              var masShiftTypeStartTime = new Date(
                date + ' ' + shifttem.masShiftTypeStartTime
              )

              if (startStamp > masShiftTypeStartTime) {
                shifttem.colorin = 'red'
              } else {
                shifttem.colorin = 'green'
              }

              if (shifttem.checkInEndStamp) {
                shifttem.checkInEndStamp = shifttem.checkInEndStamp
                shifttem.colorout = 'green'
              } else {
                shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                shifttem.colorout = '-'
              }
            } else {
              shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
              shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
              shifttem.colorin = '-'
              shifttem.colorout = '-'
            }
          })
          dt.shifttem = dt.shifttem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
          this.dataByEmp = dt
          //  console.log('dt : ', this.dataByEmp)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    mapGetDataCheckRisk (dt) {
      dt.forEach((shifttem) => {
        var position = {
          lat: null,
          lng: null
        }
        if (shifttem.color) {
          position = {
            lat: Number(shifttem.Lat),
            lng: Number(shifttem.Long)
          }
          //  console.log(shifttem.color)
          if (shifttem.color === 'สีส้ม') {
            shifttem.iconIn = require('@/assets/virus.png')
          } else {
            shifttem.iconIn =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fin.png?alt=media'
          }
          // this.imageUrlBack = require('@/assets/Icon/Back.jpg')
          shifttem.positionIn = position
          this.center = position
        } else {
          shifttem.positionIn = position
        }
      })
    },
    exportEmpInfo () {
      var greenItem = []
      this.dataItemGreen.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color,
          'ข้อ1': element.formSaveRisk1,
          'ข้อ2': element.formSaveRisk21,
          'ข้อ3': element.formSaveRisk3,
          'ข้อ4': element.formSaveRisk4,
          'ข้อ5': element.formSaveRisk5,
          'ข้อ6': element.formSaveRisk6,
          'ข้อ7': element.formSaveRisk7
        }
        greenItem.push(s)
      })
      var yellowItem = []
      this.dataItemYellow.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color,
          'ข้อ1': element.formSaveRisk1,
          'ข้อ2': element.formSaveRisk21,
          'ข้อ3': element.formSaveRisk3,
          'ข้อ4': element.formSaveRisk4,
          'ข้อ5': element.formSaveRisk5,
          'ข้อ6': element.formSaveRisk6,
          'ข้อ7': element.formSaveRisk7
        }
        yellowItem.push(s)
      })
      var orangeItem = []
      this.dataItemOrange.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color,
          'ข้อ1': element.formSaveRisk1,
          'ข้อ2': element.formSaveRisk21,
          'ข้อ3': element.formSaveRisk3,
          'ข้อ4': element.formSaveRisk4,
          'ข้อ5': element.formSaveRisk5,
          'ข้อ6': element.formSaveRisk6,
          'ข้อ7': element.formSaveRisk7
        }
        orangeItem.push(s)
      })
      var redItem = []
      this.dataItemRed.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color,
          'ข้อ1': element.formSaveRisk1,
          'ข้อ2': element.formSaveRisk21,
          'ข้อ3': element.formSaveRisk3,
          'ข้อ4': element.formSaveRisk4,
          'ข้อ5': element.formSaveRisk5,
          'ข้อ6': element.formSaveRisk6,
          'ข้อ7': element.formSaveRisk7
        }
        redItem.push(s)
      })
      var riskItem = []
      this.dataItemComplate.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color
        }
        riskItem.push(s)
      })
      var cantRiskItem = []
      this.dataItemCantRisk.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'อีเมล': element.empEmail,
          'ปี': element.checkInYear,
          'เดือน': element.checkInMonth,
          'วัน': element.checkInDay,
          'กะ': element.masShiftTypeName,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระดับสีประเมินความเสี่ยง': element.color
        }
        cantRiskItem.push(s)
      })
      var green = XLSX.utils.json_to_sheet(greenItem)
      var yellow = XLSX.utils.json_to_sheet(yellowItem)
      var orange = XLSX.utils.json_to_sheet(orangeItem)
      var red = XLSX.utils.json_to_sheet(redItem)
      var risk = XLSX.utils.json_to_sheet(riskItem)
      var cantRisk = XLSX.utils.json_to_sheet(cantRiskItem)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, risk, 'ทำแบบประเมินเรียบร้อย') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, cantRisk, 'ยังไม่ทำแบบประเมิน') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, green, 'สีเขียว') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, yellow, 'สีเหลือง') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, orange, 'สีส้ม') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, red, 'สีแดง') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'Covid-Report(' + this.day + ' ' + this.month + ' ' + this.year + ').xls') // name of the file is 'book.xlsx'
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          //  console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          //  console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          //  console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    }
  }
}
</script>
<style scope>
:root {
  --nav-text: #b61c1c;
  --table-head-bg: #b61c1c;
  --table-head-text: #ffff;
  --table-body-row-even: #b1c9ea;
  --table-body-row-odd: #ffffff;
  --table-body-text: #1b437c;
}
#header-green {
  background-color: #00c853;
}
#header-yellow {
  background-color: #ffd600;
}
#header-orange {
  background-color: #ff9800;
}
#header-red {
  background-color: #d32f2f;
}
#header-purple {
  background-color: #4527A0;
}
#header-blue {
  background-color: #0D47A1;
}
/* .v-data-table-header {
  background-color: var(--table-head-bg) !important;
} */
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: var(--table-head-text) !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 8px 5px 8px 15px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
  background: var(--table-body-row-even);
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(odd) {
  background: var(--table-body-row-odd);
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  color: var(--table-body-text) !important;
}
.theme--light.v-data-table .v-data-table-header th.sortable.active,
.theme--light.v-data-table
  .v-data-table-header
  th.sortable.active
  .v-data-table-header__icon,
.theme--light.v-data-table .v-data-table-header th.sortable:hover {
  color: var(--table-head-text) !important;
}
.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  color: var(--table-head-text) !important;
}
.menu-head {
  color: var(--nav-text) !important;
  font-size: 35px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashbord/DashbordCovid.vue